import * as React from 'react';

import { wrapDisplayName } from '../displayName';

export function withEmptyRendering<T>(validator: (props: T) => boolean) {
  return function wrap(
    Component: React.ComponentType<React.PropsWithChildren<T>>,
  ): React.ComponentType<React.PropsWithChildren<T>> {
    function Wrapper(props: T) {
      const isInvalid = validator(props);

      if (isInvalid) {
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return <Component {...(props as any)} />;
    }

    Wrapper.displayName = wrapDisplayName(Component, 'withEmptyRendering');

    return Wrapper;
  };
}
